import { CheckMyPermissionDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryCheckMyPermissions, useQueryWhoAmI } from '../queries/directory.queries';

export function useAvailableUIFeatures() {
  const user = useQueryWhoAmI();

  return user.data?.account.availableUiFeatures || [];
}

export function useHasUIFeatures(availableUIFeatures: string[]) {
  const user = useQueryWhoAmI();
  for (const feature of availableUIFeatures) {
    if (!user.data || !user.data.account.availableUiFeatures.includes(feature)) {
      return {
        isLoading: user.isLoading,
        hasAllFeatures: false
      };
    }
  }

  if (user.isLoading) {
    return {
      isLoading: user.isLoading,
      hasAllFeatures: false
    };
  }

  return {
    isLoading: user.isLoading,
    hasAllFeatures: true
  };
}

export function useHasPermissions(checks: CheckMyPermissionDto[]): {
  isLoading: boolean;
  hasAllPermissions: boolean;
  hasSomePermissions: boolean;
} {
  const results = useQueryCheckMyPermissions(checks);

  if (checks.length === 0) {
    return {
      isLoading: false,
      hasAllPermissions: false,
      hasSomePermissions: false
    };
  }

  const positiveResults = results.filter((result) => !result.isLoading && result.data?.allowed === true);

  const hasAllPermissions = positiveResults.length === checks.length;
  const hasSomePermissions = positiveResults.length > 0;

  return {
    isLoading: results.some((result) => result.isLoading),
    hasAllPermissions,
    hasSomePermissions
  };
}
